var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'bizcomp-query-lpwd bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('change-pwd',{attrs:{"way":_vm.way}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }